<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Insurance</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Stand out in the competitive insurance landscape with LocalScale, your partner in targeted advertising solutions</p>
                        <p>As an insurance agency, building trust and credibility in your local community is essential for success.</p>
                        <p>With LocalScale, you can amplify your agency's visibility and connect with individuals seeking insurance solutions tailored to their needs.</p>
                        <p>Whether you specialize in auto, home, life, or commercial insurance, our precision-targeted ad network allows you to reach potential clients in your target markets with ease.</p>
                        <p>By leveraging LocalScale, you can ensure that your agency remains top-of-mind when individuals are considering their insurance options, ultimately driving more leads and conversions.</p>
                        <p>Let us help you grow your agency and solidify your position as a trusted insurance provider in your community.</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-insurance.png" alt="Insurance">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“LocalScale has been a game-changer for our insurance agency. Their targeted advertising solutions have significantly increased our online visibility and attracted quality leads. Thanks to LocalScale, we've been able to grow our client base and expand our reach in the community.”</h3>
                    <p class="testimonial-customer">– Jessica Miller, Agency Manager at SecureShield Insurance Agency</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>

    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
